// extracted by mini-css-extract-plugin
module.exports = {"labelQuestion":"Label_labelQuestion__2F3AF","labelQuestionHeader":"Label_labelQuestionHeader__6--33","labelError":"Label_labelError__2hNB-"};